<label mat-dialog-title>Return Item</label>
<mat-dialog-content class="dialog-content">
  <!-- Product Info -->
  <div class="product-table">
  <div class="product-row header">
    <div>Product</div>
    <div>Qty</div>
    <div>Size</div>
    <div>Price</div>
  </div>
  <div class="product-row" *ngFor="let data of data?.item">
    <div class="product-info">
      <img [src]="imageBaseUrl + data?.image" />
      <span>{{ data?.product_name | titlecase }}</span>
    </div>
    <div class="d-flex justify-content-center" >{{ data?.quantity }}</div>
    <div class="d-flex justify-content-center">{{ data?.size }}</div>
    <div class="d-flex justify-content-center">₹{{ data?.price }}</div>
  </div>
</div>

  <mat-divider></mat-divider>
  <!-- Reason Selection -->
  <label class="section-title">Select Reason</label>
  <mat-radio-group [(ngModel)]="selectedReason" class="price">
    <mat-radio-button value="Damaged product">Damaged product</mat-radio-button>
    <mat-radio-button value="Wrong item">Wrong item received</mat-radio-button>
    <mat-radio-button value="Size issue">Size issue</mat-radio-button>
    <mat-radio-button value="Quality issue">Quality not good</mat-radio-button>
    <mat-radio-button value="Other">Other</mat-radio-button>
  </mat-radio-group>
  <!-- Return Type -->
  <h4 class="section-title">Return Type</h4>
  <mat-radio-group [(ngModel)]="returnType">
    <mat-radio-button value="Refund">Refund</mat-radio-button>
    <mat-radio-button value="Replace">Replace</mat-radio-button>
  </mat-radio-group>
  <!-- Upload Image -->
  <div class="upload-section" *ngIf="selectedReason === 'Damaged product' || selectedReason === 'Wrong item'">
    <input #fileInput type="file" multiple accept="image/*" (change)="onImageSelect($event)" style="display: none">
    <button (click)="fileInput.click()" mat-raised-button color="primary">Upload Image</button>
    <div class="preview-container mt-2">
    <img *ngFor="let img of previewImages" [src]="img" class="preview-img">
    </div>
  </div>
  <div class="refund-summary" *ngIf="data?.item?.length >= 1">
  <div class="summary-row">
    <span>Total Items:</span>
    <span>{{ data?.item?.length }}</span>
  </div>
  <div class="summary-row"  *ngIf="returnType === 'Refund'">
    <span>Total Refund:</span>
    <span class="amount">₹{{ getTotalRefund() }}</span>
  </div>

</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="secondary">Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="!selectedReason"
          (click)="submitReturn()">
    Confirm Return
  </button>
</mat-dialog-actions>